export default "__VITE_ASSET__BN9BgvO2__"